import ViewDetails from "../../utils/utilities/ViewDetails";

// NewEvent Context
import { NewEventProvider } from "../../contexts/NewEvent";

import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';


// Tabs
import GeneralTab from "./Tabs/General";

const tabContent = [
  {panel: "general", content: <GeneralTab />},
]

const ViewShipment = () => {

  const tabs = [
    {label: "General", icon: <ContactPageOutlinedIcon fontSize="small" />},
    
  ];

  return (
    <NewEventProvider>
      <ViewDetails title="Shipment" identifier="shipment_num" tabs={tabs} tabContent={tabContent} url="shipments">

      </ViewDetails>
    </NewEventProvider>
  )
};

export default ViewShipment;